var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mb-4" },
    [
      _vm.loading
        ? _c("document-level-automations-loader")
        : _vm.triggersEmpty
        ? _c("div", [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("automations.noAutomationsRegistered")) +
                "\n  "
            ),
          ])
        : _c(
            "div",
            _vm._l(_vm.triggersWithAutomationByLevel, function (triggerKey) {
              return _c("automation-type", {
                key: triggerKey,
                attrs: {
                  trigger: _vm.TRIGGER_BY_KEY(triggerKey, _vm.level),
                  automations: _vm.AUTOMATIONS_BY_TRIGGER(
                    triggerKey,
                    _vm.level
                  ),
                  level: _vm.level,
                },
              })
            }),
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }